import {  useQuery,useQueryClient,useMutation  } from '@tanstack/react-query';
import { listOrders,fetchOrderDetails,downloadOrders,updateOrder } from './orders.api';

export const useOrders = ({ filters, page, perPage,action }) => {
    return useQuery({
      queryKey: ['orders', filters, page, perPage,action],
    queryFn: () => listOrders({ filters, page, perPage,action }),
      keepPreviousData: true,
  });
};
export const useDownloadOrders = () => {
  return useMutation({
    mutationFn: downloadOrders
    });
  };
  export function useOrderDetails(orderid, enabled = true) {
    return useQuery({
      queryKey: ['order-details', orderid],
      queryFn: () => fetchOrderDetails(orderid),
      enabled: !!orderid && enabled,
    });
  }

  export const useUpdateOrder = (options = {}) => {
    return useMutation({
      mutationFn: updateOrder,
      ...options
    });
  };

